import React, { Component } from 'react';
import imgExit from './images/exit.svg';
import {TYYPPI, TESTIN_TILA} from './constants';

/**
 * 
 */
class Vaihtoehto extends Component {
  render() {
	
    let tyyliluokka;	
    if (this.props.oikein) {
        tyyliluokka = "valinta oikein valinta-" + this.props.testiryhmä;
    } else {
        tyyliluokka = "valinta valinta-" + this.props.testiryhmä;
    }

    return (
      <button className={tyyliluokka} onClick={() => this.props.onClick()} disabled={ this.props.arvo.piilota }>
        { this.props.arvo.vastaus }
      </button>
    );
  }  		
}	

/**
 * 
 */
class Ajastin extends Component {
	
  render() {

	// Alkuperäinen ajastin poistettu käytöstä, koska 
	// harjoituksen aikana ei myöskään tarvitse näkyä 
	// kuluva aika.
	return (  
	  <div className="ajastin"></div>			  
	);

	/* 
    if (this.props.tyyppi === TYYPPI.HARJOITUS) {
  
	  let minuutit = Math.floor(this.props.aika / 60);
      let sekunnit = ('00'+(this.props.aika % 60)).slice(-2);

      return ( 
			  <div className="ajastin">
	        <div>{this.props.testinimi}</div>
			    <div>Aika: {minuutit}:{sekunnit}</div>
			  </div>
      ); 
			  
	} else {

      return (  
			  <div className="ajastin"></div>			  
      );
	  
	}
	*/

  }  
}


class Testi extends Component {

  /**
	 * Komponentin konstruktori, jossa alustetaan state-muuttuja ja tehdään
	 * bind-kytkennät.
	 * @constructor
	 * @param {*} props 
	 */	
  constructor(props) {

    // Alustetaan props ja state.
    super(props);	
    this.state = this.alustaTesti()

    // Kytketään this funktioiden takaisinkutsua varten.
    this.tick = this.tick.bind(this)
		this.seuraavaTehtävä = this.seuraavaTehtävä.bind(this)

  }	

  /**
	 * Käynnistää ajastimen heti, kun komponentti on liitetty
	 * DOM-puuhun.
	 */
  componentDidMount() {
	  this.timer = setInterval(this.tick, 1000);				
  }

  /**
	 * Lopettaa ajastimen toiminnan, kun komponentti ollaan
	 * poistamassa DOM-puusta.
	 */
  componentWillUnmount() {		
    clearInterval(this.timer);
  }

	/**
	 * Funktio, joka palauttaa state-muuttujan alustuksessa käytettävän
	 * oliomuuttujan.
	 * @returns {Object}
	 */
  alustaTesti() {
		
		// Luodaan state-muuttujiin tallennettavat muuttujat.
    let testinimi = this.props.testinimi;                // Testin nimi
	  let suoritettavat =  this.props.tehtävät.map(a => JSON.parse(JSON.stringify(a)))  // Kopio suoritettavista tehtävistä
	  let tyyppi = this.props.tyyppi;                      // Testin tyyppi
	  let kokonaisaika = this.props.aika;                  // Testin pituus
	  let tehtäviä = this.props.tehtäviä;                  // Tehtävien kokonaismäärä
	  let testiryhmä = this.props.testiryhmä;              // Testin testiryhmä.
	  let suoritettava = suoritettavat.shift();            // Ensimmäinen suoritettava tehtävä
	  let alkupSuoritettava = JSON.parse(JSON.stringify(suoritettava)) ;  // Tehtävän alkuperäinen versio uusintaa varten (deep copy)
	  let suoritettu = 0;                                  // Suoritettujen tehtävien kokonaismäärä
	  let uusitaan = false;                                // Uusitaanko tehtävä -lippu
	  let pisteet = 0;                                     // Pisteiden kokonaismäärä
	  let aika = 0;                                        // Testin suoritukseen käytetty aika
	  let tila = TESTIN_TILA.KÄYNNISSÄ;                    // Testin tila
		let vastattu = false;                                // Onko tehtävään vastattu?
	
	  // Palautetaan state-muuttujan sisältö oliomuuttujana.
	  return {
	    aika: aika,
			alkupSuoritettava: alkupSuoritettava,
		  kokonaisaika: kokonaisaika,
			pisteet: pisteet,
			suoritettava: suoritettava,
			suoritettavat: suoritettavat,
			suoritettu: suoritettu,
			tehtäviä: tehtäviä,
			testinimi: testinimi,
	    testiryhmä: testiryhmä,
			tila: tila,
			tyyppi: tyyppi,      
	    uusitaan: uusitaan,
			vastattu: vastattu,
    }
	
  }  

	/**
	 * Lopettaa testin suorituksen kutsumalla props-muuttujissa
	 * välitettyä lopetusfunktiota, joka lopettaa komponentin 
	 * renderöinnin.
	 */
  lopetaTesti() {
	  this.props.lopeta()
  }

	/**
	 * Määritellään käyttäjälle seuraava tehtävä. Jos edellisen vastaus
	 * epäonnistui, uusitaan edellinen. Muuten otetaan suoritettavista
	 * tehtävistä seuraava.
	 * Versio 0.8.1 / 27.9.2017 
	 *   Lisättiin interval-kutsun peruutus silloin, kun testi on 
	 *   suoritettu. Aikaisemmin interval-kutsu jäi peruuttamatta, 
	 *   jolloin se jäi kummittelemaan testin uudelleensuorituksessa.
	 */
  seuraavaTehtävä() {

    // Haetaan tarvittavat state-muuttujat omiin muuttujiinsa.
    let alkupSuoritettava = this.state.alkupSuoritettava;  // Kopio alkuperäisestä tehtävästä
		let pisteet = this.state.pisteet;                      // Käyttäjän yhteispistemäärä
    let suoritettava = this.state.suoritettava;            // Suoritettavasta tehtävästä
	  let suoritettavat =  this.state.suoritettavat;         // Jäljellä olevat suoritettavat tehtävät
	  let suoritettu = this.state.suoritettu;                // Vastattujen tehtävien yhteismäärä
	  let tehtäviä = this.state.tehtäviä;                    // Suoritettavien tehtävien kokonaismäärä
	  let tila = this.state.tila;                            // Testin tila
    let uusitaan = this.state.uusitaan;	                   // Tieto siitä, uusitaanko tehtävä 
	  let vastaus = null;                                    // Näytettävä vastaus, oletusarvona tyhjä
		let vastattu = false;                                  // Oletuksena uuteen tehtävään ei ole vastattu
	
	  // Tehtävään vastattiin oikein, kasvatetaan vastattujen tehtävien
		// kokonaismäärää.
	  suoritettu++;
	
    // Tarkistetaan menikö tehtävä uusintaan eli valitsiko käyttäjä
		// ensimmäiseksi väärän vaihtoehdon. 
	  if (uusitaan) {

			// Tehtävä ei mennyt kerrasta nappiin, laitetaan sama tehtävä
			// uudelleen. 
			//  - uusintayritystä ei oletuksena uusita
			//  - poistetaan suoritettavista tehtävistä seuraava
			//  - asetetaan suoritettavaksi tehtäväksi alkuperäinen tehtävä
			//    muuttamattomana (deep copy)
      //  - sekoitetaan vastausvaihtoehdot uuteen järjestykseen
	    uusitaan = false;
			suoritettavat.shift();   
	    suoritettava = JSON.parse(JSON.stringify(alkupSuoritettava));
			suoritettava.tulos.shuffle();
	  
	  } else {

		  // Tehtävään vastattiin kerrasta oikein, siirrytään seuraavaan 
			// tehtävään.  
			//  - kasvatetaan pistesaldoa yhdellä
			//  - otetaan seuraava tehtävä suoritettavaksi
			//  - asetetaan tehtävä alkuperäiseksi tehtäväksi (deep copy)
	    pisteet++;
	    suoritettava = suoritettavat.shift();
			if (suoritettava !== undefined ) {
	      alkupSuoritettava = JSON.parse(JSON.stringify(suoritettava));
			}
			
	  }
	
    // Tarkistetaan ollaanko tekemässä loputtomasti tehtäviä ja onko
		// tehtävät käyty lävitse.
	  if (tehtäviä === 0 && suoritettavat.length === 0) {

			// Tehtävät on suoritettu, kopioidaan uudet tehtävät suoritettavien
			// pohjaksi ja sekoitetaan uuteen järjestykseen.
			// Huomaa, että tehtävät-muuttuja on olioita sisältävä taulukko.
      suoritettavat = this.props.tehtävät.map(a => JSON.parse(JSON.stringify(a))) 
			suoritettavat.shuffle();

		}

	  // Tarkistetaan onko kaikkiin tehtäviin vastattu.
	  if (tehtäviä > 0 && suoritettu === tehtäviä) {

      // Keskeytetään ajastin.
			clearInterval(this.timer);

			// Kaikkiin tehtäviin on vastattu, näytetään koostesivu.
		  tila = TESTIN_TILA.SUORITETTU;

	  }	

	  // Tallennetaan state-muuttujaan tulleet muutokset.	  
	  this.setState({ 
		  alkupSuoritettava: alkupSuoritettava,
	    pisteet: pisteet,
	    suoritettava: suoritettava, 
	    suoritettavat: suoritettavat, 
		  suoritettu: suoritettu, 
		  tila: tila,
		  uusitaan: uusitaan, 			    
		  vastaus: vastaus,
			vastattu: vastattu
	  });	  
	  
  }
	
  /**
	 * Tarkistaa käyttäjän valitseman vastauksen. Jos valinta oli oikea, niin 
	 * näytetään oikea vastaus ja piilotaan loput näkyvissä olevat. Muuten
	 * piilotaan väärä valinta.
	 * @param {number} i - vastausvaihtoehdon järjestysindeksi
	 */
  tarkistaValinta(i) {

    // Haetaan tarvittavat state-muuttujat omiin muuttujiinsa.
	  let suoritettava = { ...this.state.suoritettava }  // Kopio suoritettavasta tehtävästä
	  let uusitaan = this.state.uusitaan;                // Tieto siitä, uusitaanko tehtävä
	  let vastaus = this.state.vastaus;                  // Vastauksena näytettävä arvo
		let vastattu = this.state.vastattu;                // Onko tehtävään jo vastattu?
		
    // Tarkistetaan, ettei käyttäjä ole jo vastannut tehtävään.
		if (!vastattu) {

	    // Oliko käyttäjän valinta oikein?	
	    if (suoritettava.tulos[i].oikein) {
		
		    // Valinta oli oikein, tallennetaan vastaus state-muuttujaan,
			  // jolloin se tulostetaan näkyville.
        vastaus = suoritettava.tulos[i].vastaus;

		    // Oikea löytyi, piilotetaan loput näkyvissä olevat väärät vaihtoehdot
        // suodattamalla indeksitaulukosta oikea vaihtoehto pois ja asettamalla
			  // lopuilla (väärillä) vaihtoehdoilla piilota-arvo todeksi.
		    // Huomaa! for (index of valinnat) -silmukka ei toimi vanhemmilla 
			  // Android-selaimilla..
		    let valinnat = [0,1,2,3];
		    valinnat = valinnat.filter(index => index !== i);		
		    for (var index = 0, pituus = valinnat.length; index < pituus; index++) {
		    	suoritettava.tulos[valinnat[index]].piilota = true;
		    }
				
        // Määritetään tehtävä vastatuksi, jotta siitä ei saada lisää
				// pisteitä.
				vastattu = true;

		    // Annetaan tehtävän vastauksen näkyä pieni hetki ja siirrytään
			  // sitten sauraavaan tehtävään. 
		    setTimeout(this.seuraavaTehtävä, 800);
		
	    } else {

			  // Valinta oli väärä, piilotaan väärä valinta ja merkitään tehtävä
			  // uudelleen suoritettavaksi.
		    suoritettava.tulos[i].piilota = true;
		    uusitaan = true;

	    }		

		} else {

      console.log("Tehtävään on jo vastattu!");

		}

		// Tallennetaan state-muuttujaan tulleet muutokset.		
	  this.setState({ 
		  suoritettava: suoritettava, 
			uusitaan: uusitaan, 
			vastaus: vastaus,	
			vastattu: vastattu,		    
		});

  } 

  /**
	 * Alustaa testin lähtötilanteeseen ja käynnistää ajastimen.
	 */
  teeUudelleen() {
	  this.setState(this.alustaTesti());
	  this.timer = setInterval(this.tick, 1000);
  }
	
	/**
	 * Keskeyttää testin suorituksen.
	 */
  keskeytaTesti() {	  
	  this.setState({tila: TESTIN_TILA.KESKEYTETTY});
  }
  
	/**
	 * Jatkaa testin suoritusta.
	 */
  jatkaTestia() {
	  this.setState({tila: TESTIN_TILA.KÄYNNISSÄ});
  }
	
  /**
	 * Huolehtii laskurin kasvatuksesta joka sekunti. Tarkistaa
	 * lisäksi, että onko testiin käytettävä aika käytetty.
	 * Versio 0.8.1 / 27.9.2017 
	 *   Poistettiin testin suorituksen tarkistus, koska sen 
	 *   tarkistus tapahtuu jo seuraavaTehtävä-funktiossa.
	 */
  tick() {      
    
	  // Aika kuluu, kun 
	  //  - testi tai harjoitus on käynnissä tai
	  //  - testi on keskeytetty.
	  if (this.state.tila === TESTIN_TILA.KÄYNNISSÄ ||
		  (this.state.tila === TESTIN_TILA.KESKEYTETTY && this.state.tyyppi === TYYPPI.TESTI)) {
	    /* if (this.state.tehtäviä > 0 && this.state.suoritettu === this.state.tehtäviä) {
	      // console.log("Tehtävät suoritettu, katkaistaan..")				
	      clearInterval(this.timer);
				this.setState({tila: TESTIN_TILA.SUORITETTU})	      	
	    } else */ 
		  if (this.state.aika === this.state.kokonaisaika && (
		             this.state.tyyppi === TYYPPI.TESTI  ||
		            (this.state.tyyppi === TYYPPI.HARJOITUS && this.state.kokonaisaika > 0))) {
	      // console.log("Aika loppui, katkaistaan..")
	      clearInterval(this.timer);
				this.setState({tila: TESTIN_TILA.SUORITETTU})	      	  
      } else {
	      let aika = this.state.aika + 1
        this.setState({aika: aika})
      }
	  }
		
  }

  /**
	 * 
	 * @param {*} index 
	 */
  renderöiVaihtoehto(index) {
	  return <Vaihtoehto arvo={this.state.suoritettava.tulos[index]} 
		                   testiryhmä={this.state.testiryhmä}
		                   onClick={() => this.tarkistaValinta(index)} />
  }	
	
  render() {

    let tila = this.state.tila;         // Testin tila
  
    if (tila === TESTIN_TILA.SUORITETTU) {
 
	    let minuutit = Math.floor(this.state.aika / 60)
      let sekunnit = ('00'+(this.state.aika % 60)).slice(-2)	
      let tulosteksti;
			let pisteteksti;

      if (this.state.tyyppi === TYYPPI.HARJOITUS) {
        tulosteksti = "Harjoituksen tiedot";	  
			} else {
        tulosteksti = "Testin tiedot";	  
			}

      if (this.state.pisteet === 1) {
				pisteteksti = "Sait yhden pisteen!";
			} else {
				pisteteksti = "Sait " + this.state.pisteet + " pistettä!";
			}
	
      /* 
        teeUudelleen luo uuden timerin ja laittaa sen vanhan kanssa käyntiin..
        
			*/


	    return (
		    <div className={"sivu sivu-" + this.state.testiryhmä}>
			  	<div className="testitiedot">
			  	  <h1>{this.state.testinimi}<div>({this.state.tyyppi})</div></h1>
			  	  <p>{pisteteksti}</p>
    	          <div className={"tulostiedot tulos-"+ this.state.testiryhmä}>
			  	    <p>{tulosteksti}</p>
			  		<table className="tulostaulukko">
					  <tbody>
				  	    <tr><td>Vastattuja tehtäviä:</td><td className="tulos">{this.state.suoritettu}</td></tr>
				  	    <tr><td>Oikein vastattuja:</td><td className="tulos">{this.state.pisteet}</td></tr>
				  	    <tr><td>Käytetty aika:</td><td className="tulos">{minuutit}:{sekunnit}</td></tr>
					  </tbody>
				  	</table>
		          </div>
				  <div className="uusinta">
				    <button className={"nappi " + this.state.testiryhmä} onClick={() => this.teeUudelleen()}>Tee uudelleen</button>
				  </div>
			    </div>
		        <div className="button-exit"><button className="imageButton" onClick={() => this.lopetaTesti()}><img src={imgExit} alt="takaisin"/></button></div>
		    </div>		
	    );

    } else if (tila === TESTIN_TILA.KESKEYTETTY) {

      let otsikko = "";
      let teksti = "";
			let nappiJatka = "";
			let nappiLopeta = ""; 
			if (this.state.tyyppi === TYYPPI.HARJOITUS) {
        otsikko = "Lopeta harjoitus";
				teksti = "Haluatko varmasti lopettaa harjoituksen?";
				nappiJatka = "Jatkan harjoitusta";
				nappiLopeta = "Lopetan harjoituksen";
			} else {
        otsikko = "Lopeta testi";
				teksti = "Haluatko varmasti lopettaa testin?";
				nappiJatka = "Jatkan testiä";
				nappiLopeta = "Lopetan testin";
			}


      return (
		
        <div className={"sivu sivu-" + this.state.testiryhmä}>		
				  <h1>{otsikko}</h1>
		      <p>{teksti}</p>
		      <div><button className={"nappi " + this.state.testiryhmä} onClick={() => this.jatkaTestia()}>{nappiJatka}</button></div>
					<div><button className={"nappi " + this.state.testiryhmä} onClick={() => this.lopetaTesti()}>{nappiLopeta}</button></div>
		    </div>  
		  
	    );
	
    } else {	

	  let status = "";
	  if (this.state.tyyppi === TYYPPI.HARJOITUS) {
		  status = <div className="stats">Tehtävä {this.state.suoritettu} - Pisteet {this.state.pisteet}</div>
	  }		

/* epäonnistunut kokeilu, jossa yritettiin saada tuloksen koko vakioksi.. */
		let tehtävä = this.state.suoritettava.tehtävä;

    let vastaus;
		if (this.state.vastaus === null) {
			vastaus = "__";
		} else {
			vastaus = this.state.vastaus;
		}

		tehtävä = tehtävä.split("?").reduce((prev,current,i) => {
			if (!i) {
				return [current];
			}
			return prev.concat(<div key={i} className="tulos">{vastaus}</div>, current);
		}, []);
		

		// tehtävä.replace("?", <div className="tulos">_</div>);	

	  return (	  
  		<div className={"sivu sivu-" + this.state.testiryhmä}>		

		    <div className="tehtava">
			    { status }
			    <div className="lasku" id="lasku">{tehtävä}</div>
			    <div className="vaihtoehdot">
			    
 			      <div className="ryhma">
				      { this.renderöiVaihtoehto(0) }
				      { this.renderöiVaihtoehto(1) }
			      </div>
			      <div className="ryhma">
			  	    { this.renderöiVaihtoehto(2) }
				      { this.renderöiVaihtoehto(3) }
			      </div>
				
			  </div>
			
		  </div>
		  <Ajastin tyyppi={this.state.tyyppi} aika={this.state.aika} kokonaisaika={this.state.kokonaisaika} testinimi={this.state.testinimi} />
			<div className="button-exit"><button className="imageButton" onClick={() => this.keskeytaTesti()}><img src={imgExit} alt="takaisin"/></button></div>
		</div>
	  );

    } 	  
  }	  
}

export default Testi;


// WEBPACK FOOTER //
// ./src/Testi.js